const bxfSend = {
    svg: '<svg style="flex-shrink: 0;forced-color-adjust: auto;fill: currentcolor; padding:0.75rem; width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M15.707.293A1 1 0 0 0 14.664.06l-14 5a.999.999 0 0 0-.111 1.835l4.586 2.292 4.64-3.314c.23-.164.514.12.35.35l-3.315 4.641 2.292 4.586c.17.34.518.552.895.552.02 0 .04 0 .06-.002a1 1 0 0 0 .883-.662l4.999-14c.129-.364.037-.77-.236-1.044"/></svg>',
};

export { bxfSend as default };
